/** True when client/lawyer may open Good Proof PreviewInstructionsModal. */
export function canOpenInstructionsPreview(
	instructions?: {
		description?: string | null;
		image_url?: string | null;
	} | null
): boolean {
	return (
		Boolean(instructions?.description?.trim()) &&
		Boolean(instructions?.image_url?.trim())
	);
}
